<template>
  <div class="EditProfile">

    <v-form @submit.prevent="submit({name: `${$root.routePrefix}.show_profile`})"
            :disabled="busy">

      <v-card class="mb-4">
        <ErrorAlert v-if="error"
                    :error="error">
        </ErrorAlert>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="busy">
            <v-icon v-if="busy">
              fal fa-spin fa-spinner
            </v-icon>
            <template v-else>
              Save
            </template>
          </v-btn>
          <v-btn :to="{name: `${$root.routePrefix}.show_profile`}"
                 :disabled="busy">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>

      <UserFormBasicInfo :form="form"
                         :photo-form="photoForm"
                         :user="user"
                         @delete-photo="deletePhoto">
      </UserFormBasicInfo>

      <UserFormContacts :form="form"
                        :user="user">
      </UserFormContacts>

      <template v-if="1===2 && teamUsesPipedrive">
        <v-card class="mb-4">
          <v-card-title>
            Pipedrive CRM
          </v-card-title>
          <v-card-text>
            <div class="mb-2">
              <a href="https://support.pipedrive.com/en/article/how-can-i-find-my-personal-api-key" target="_blank">
                How can I find my personal API key?
              </a>
            </div>

            <v-text-field v-model="form.pipedrive_api_token"
                          label="My Pipedrive Personal API Key"
                          :placeholder="isPipedriveTokenSet ? 'Your personal API key is already set.' : 'Your personal API key is not set.'"
                          :disabled="busy"
                          outlined
                          :error-messages="form.errors.get('pipedrive_api_token')">
            </v-text-field>
          </v-card-text>
        </v-card>
      </template>

      <CommunicationPreferences :form="form"
                                :user="user">
      </CommunicationPreferences>

      <UserPermissions :form="form"
                       :user="user">
      </UserPermissions>

      <v-card class="mb-4">
        <ErrorAlert v-if="error"
                    :error="error">
        </ErrorAlert>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="busy">
            <v-icon v-if="busy">
              fal fa-spin fa-spinner
            </v-icon>
            <template v-else>
              Save
            </template>
          </v-btn>
          <v-btn :to="{name: `${$root.routePrefix}.show_profile`}"
                 :disabled="busy">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import UserFormBasicInfo from '../users/components/UserFormBasicInfo';
import userService from '../../services/userService';
import ProfileToolbar from './components/ProfileToolbar';
import CommunicationPreferences from "../users/components/CommunicationPreferences";
import UserPermissions from "../users/components/UserPermissions";
import UserFormAddress from "../users/components/UserFormAddress";
import ErrorAlert from '../../components/ErrorAlert.vue';
import UserFormContacts from '../users/components/UserFormContacts.vue';

export default {
  components: {UserFormContacts, ErrorAlert, UserFormAddress, UserPermissions, CommunicationPreferences, ProfileToolbar, UserFormBasicInfo},
  metaInfo() {
    this.$store.commit('setTitle', this.user.name);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Users', exact: true, to: {name: 'users'},},
        {text: 'Show User'}
      ],
      busy: false,
      error: null,
      form: userService.initForm(),
      photoForm: new Form({
        photo: null
      })
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'isAdmin',
      'isPipedriveTokenSet', // MLD-7203
      'team',
      'teamUsesPipedrive', // MLD-7203
      'user',
    ]),
  },
  created() {
    this.initializeForm(this.user);
  },
  methods: {
    initializeForm(user) {
      userService.initFormForUser(this.form, user);
    },
    async submit(to = null) {
      this.error = null;
      this.busy = true;

      await this.uploadPhoto();

      if (this.error) {
        return;
      }

      await this.updateProfile();

      if (this.error) {
        return;
      }

      if (to) {
        await this.$router.push(to);
      } else {
        this.$emit('updated');
      }
    },
    async uploadPhoto() {
      try {
        this.photoForm.startProcessing();
        if (this.photoForm.photo) { // MLD-7821
          console.log('uploading photo', this.photoForm.photo);
          const data = await userService.uploadPhoto(this.user.id, this.photoForm.photo);
          this.form.photo_url = data.url;
        }
      } catch (error) {
        this.photoForm.handleErrors(error);
        this.error = error;
        this.busy = false;
      }
    },
    async updateProfile() {
      try {
        this.form.startProcessing();
        const user = await userService.updateUser(this.form, this.user.id);
        await this.$store.dispatch('initStore');
        if (user.id === this.user.id) {
          this.$store.commit('setSuccessMessage', `Profile updated.`)
        } else {
          this.$store.commit('setSuccessMessage', `${user.name} updated.`)
        }
      } catch (error) {
        this.error = error;
        this.busy = false;
      }
    },
    async deletePhoto() {
    }
  }
}
</script>
